import { render, staticRenderFns } from "./ProductivityCompany.vue?vue&type=template&id=3c22caa9&scoped=true"
import script from "./ProductivityCompany.vue?vue&type=script&lang=js"
export * from "./ProductivityCompany.vue?vue&type=script&lang=js"
import style0 from "./ProductivityCompany.vue?vue&type=style&index=0&id=3c22caa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22caa9",
  null
  
)

export default component.exports